export const FALE_CONOSCO_EMAIL = 'faleconosco@muviflex.com.br'
